/* eslint-disable */
import MyMapsContextMenu from "~/es6/mymaps.contextmenu";

/**
 * Kontextové menu pro Aktivity
 */
export default class ActivitiesContextMenu extends MyMapsContextMenu {
	constructor(opts) {
		super(opts);

		if (this._opts.foreign) {
			this._create([
				"share",
				"add-to-folder"
			]);
		}
		else {
			this._create([
				"share",
				"link-to-folder",
				"edit",
				"delete"
			]);
		}
	}
}
